module.exports = __webpack_public_path__ + "img/top.34b649b.png";